export * from "./equiRectangularCubeTexture.pure";

import "../../Materials/Textures/baseTexture.polynomial";
